import classNames from 'classnames';

import iconVolume from '@/assets/icon/icon-volume.svg';
import { ReactComponent as IconArrowDown } from '@/assets/icon-arrow-down.svg';
import { useI18nContext } from '@/i18n/I18n';
import { DOMAIN, DOMAIN_TYPE } from '@/utils/constants';
import { isMainNet } from '@/utils/env';

import styles from './index.module.less';

const ApiAlert = () => {
  const [$t] = useI18nContext();

  const getHost = () =>
    `https://${
      isMainNet ? '' : 'testnet-'
    }announcements.${DOMAIN}.${DOMAIN_TYPE}`;

  return (
    <div
      className={classNames(styles['api-alert'], {
        [styles['isSubAccountPage']]:
          window.location.pathname === '/app/user/subaccount-api-management',
      })}
    >
      <div className={styles['api-alert-body']}>
        <img className={styles['api-alert-volume']} src={iconVolume} alt="" />
        <div className={styles['api-alert-text']}>
          {$t('BybitOpenAPIServices') === 'BybitOpenAPIServices'
            ? 'Bybit OpenAPI Services: Transition from Legacy Version to New V5 API.'
            : $t('BybitOpenAPIServices')}
        </div>
        <a
          className={styles['api-alert-btn']}
          href={`${getHost()}/en/article/bybit-openapi-services-transition-from-legacy-version-to-new-v5-api-blt25b43a5738c00765/`}
          target="_blank"
          rel="noreferrer"
        >
          {$t('Read more')}
          <IconArrowDown />
        </a>
      </div>
    </div>
  );
};

export default ApiAlert;
